import React from "react";
import styled from "styled-components/macro";

import {
  Drawer as MuiDrawer,
} from "@mui/material";


import { SidebarItemsType } from "../../types/sidebar";
import SidebarNav from "./SidebarNav";

const Drawer = styled(MuiDrawer)`
  border-right: 0;

  > div {
    border-right: 0;
  }
`;

export type SidebarProps = {
  PaperProps: {
    style: {
      width: number;
    };
  };
  variant?: "permanent" | "persistent" | "temporary";
  open?: boolean;
  onClose?: () => void;
  items: {
    title: string;
    pages: SidebarItemsType[];
  }[];
  showFooter?: boolean;
};

const Sidebar: React.FC<SidebarProps> = ({
  items,
  showFooter = true,
  ...rest
}) => {
  return (
    <Drawer variant="permanent" {...rest} className="sidebar-nav">
      <SidebarNav items={items} />
    </Drawer>
  );
};

export default Sidebar;
